/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, HostListener, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { DataChatService } from 'src/chatbot/service/dataChat.service';

const FOCUSABLE_SELECTOR =
  'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

@Component({
  selector: 'chat-bot-info',
  standalone: true,
  imports: [ CommonModule, TranslateModule ],
  templateUrl: './chatBotInfo.component.html',
  styleUrl: './chatBotInfo.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatBotInfoComponent {
    private modalController = inject(ModalController);
    private host = inject<ElementRef<HTMLElement>>(ElementRef);
    public dataChat = inject(DataChatService);

    /**
     * CMAD-231 (WCAG 2.4.3 / 2.1.2): la trampa de foco de Ionic reacciona a eventos focus del
     * documento y no tiene sentinelas, así que Tab desde el último control puede salir del
     * documento (a la UI del navegador o, embebido en un iframe, a la página anfitriona) sin que
     * Ionic pueda recuperarlo. Se cicla el Tab dentro del contenido del diálogo. No colisiona con
     * Ionic: al prevenir el salto no llega ningún evento focus externo que corregir.
     */
    @HostListener('keydown', ['$event'])
    cycleTab(event: KeyboardEvent) {
        if (event.key !== 'Tab')
            return;

        const focusables = Array.from(this.host.nativeElement.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR));
        if (!focusables.length)
            return;

        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        } else if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        }
    }

    closeModal(){
        this.modalController.dismiss();
    }
 }
